export default function () {
  return {
    networkErrors: {},
    rolesets: [],
    networkRoles: []
  };
}
